// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"385dfebe","461":"560a3da8","468":"53471669","886":"cb5a3fa4","922":"52f7e65d"}[chunkId] + ".chunk.js";
};